module.exports = __webpack_public_path__ + "static/media/instagram-small.f5456764.webp";